export default "__VITE_ASSET__CbWsuGVG__"